import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';

import TabBar from './TabBar';

function TabBarContainer({ state, descriptors, navigation }) {
  const onPress = useCallback(
    (key, name, isFocused) => () => {
      const event = navigation.emit({
        type: 'tabPress',
        target: key,
        canPreventDefault: true,
      });
      if (!isFocused && !event.defaultPrevented) {
        navigation.navigate({
          name,
          merge: true,
        });
      }
    },
    [navigation],
  );
  const onLongPress = useCallback(
    (key) => () => {
      navigation.emit({
        type: 'tabLongPress',
        target: key,
      });
    },
    [navigation],
  );
  const tabs = useMemo(
    () =>
      state.routes.map((route, index) => ({
        id: route.key,
        isFocused: state.index === index,
        onPress: onPress(route.key, route.name, state.index === index),
        onLongPress: onLongPress(route.key),
        label: descriptors[route.key].options.tabBarLabel,
        icon: descriptors[route.key].options.tabBarIcon,
      })),
    [state, descriptors, navigation],
  );
  return <TabBar tabs={tabs} />;
}

TabBarContainer.propTypes = {
  state: PropTypes.object.isRequired,
  descriptors: PropTypes.object.isRequired,
  navigation: PropTypes.object.isRequired,
};

export default TabBarContainer;
